<template>
  <div v-if="plate">
    <h3>
      In the last 10yrs have you been treated or prescribed medication for any
      of the following:
    </h3>

    <div class="mb-6">
      <v-checkbox
        v-model="disease[DiseaseTypes.cancer].isSelected"
        label="Cancer"
      />

      <div
        v-if="disease[DiseaseTypes.cancer].isSelected"
        class="questions-inner"
      >
        <p>Was it squamous cell or Basil cell:</p>

        <v-radio-group
          v-model="disease[DiseaseTypes.cancer].isSquamousCell"
          row
        >
          <v-radio label="Yes" :value="true" />
          <v-radio label="No" :value="false" />
        </v-radio-group>
      </div>

      <v-checkbox
        v-model="disease[DiseaseTypes.heartAttack].isSelected"
        label="Heart attack"
      />

      <div
        v-if="disease[DiseaseTypes.heartAttack].isSelected"
        class="questions-inner"
      >
        <h4>Blood thinners:</h4>

        <v-radio-group
          v-model="disease[DiseaseTypes.heartAttack].bloodThinner"
          column
        >
          <v-radio value="Currently" label="Currently" />
          <v-radio value="Within 5yrs" label="Within 5yrs" />
          <v-radio value="Over 5yrs/none" label="Over 5yrs/none" />
        </v-radio-group>

        <h4>Treated Timeframe:</h4>

        <v-radio-group
          v-model="disease[DiseaseTypes.heartAttack].treatedTimeframe"
          column
        >
          <v-radio value="Within 2yrs" label="Within 2yrs" />
          <v-radio value="Over 2yrs" label="Over 2yrs" />
          <v-radio value="Over 10yrs" label="Over 10yrs" />
        </v-radio-group>
      </div>

      <v-checkbox
        v-model="disease[DiseaseTypes.heartDisease].isSelected"
        label="Heart disease"
      />

      <div
        v-if="disease[DiseaseTypes.heartDisease].isSelected"
        class="questions-inner"
      >
        <h4>Blood thinners:</h4>

        <v-radio-group
          v-model="disease[DiseaseTypes.heartDisease].bloodThinner"
          column
        >
          <v-radio value="Currently" label="Currently" />
          <v-radio value="Within 5yrs" label="Within 5yrs" />
          <v-radio value="Over 5yrs/none" label="Over 5yrs/none" />
        </v-radio-group>

        <h4>Treated Timeframe:</h4>

        <v-radio-group
          v-model="disease[DiseaseTypes.heartDisease].treatedTimeframe"
          column
        >
          <v-radio value="Within 2yrs" label="Within 2yrs" />
          <v-radio value="Over 2yrs" label="Over 2yrs" />
          <v-radio value="Over 10yrs" label="Over 10yrs" />
        </v-radio-group>
      </div>

      <v-checkbox
        v-model="disease[DiseaseTypes.stroke].isSelected"
        label="Stroke"
      />

      <div
        v-if="disease[DiseaseTypes.stroke].isSelected"
        class="questions-inner"
      >
        <h4>Was it a TIA?</h4>

        <v-radio-group v-model="disease[DiseaseTypes.stroke].tia" row>
          <v-radio label="Yes" :value="true" />
          <v-radio label="No" :value="false" />
        </v-radio-group>

        <h4>Any Paralysis</h4>

        <v-radio-group v-model="disease[DiseaseTypes.stroke].paralysis" row>
          <v-radio label="Yes" :value="true" />
          <v-radio label="No" :value="false" />
        </v-radio-group>
      </div>

      <v-checkbox
        v-model="disease[DiseaseTypes.diabetes].isSelected"
        label="Diabetes"
      />

      <div
        v-if="disease[DiseaseTypes.diabetes].isSelected"
        class="questions-inner"
      >
        <v-radio-group
          v-model="disease[DiseaseTypes.diabetes].treatmentType"
          row
        >
          <v-radio label="Insulin" value="Insulin" />
          <v-radio label="Pill" value="Pill" />
        </v-radio-group>

        <h4>What's your A1C?</h4>

        <v-text-field
          v-model="disease[DiseaseTypes.diabetes].a1c"
          placeholder="A1c"
          class="input-short"
        />

        <h4>Any complications?</h4>

        <v-radio-group
          v-model="disease[DiseaseTypes.diabetes].complications"
          row
        >
          <v-radio label="Yes" :value="true" />
          <v-radio label="No" :value="false" />
        </v-radio-group>
      </div>

      <v-checkbox v-model="plate.isAnyHeart" label="None" />
    </div>

    <h3>Any respiratory operations:</h3>

    <div class="mb-6">
      <v-checkbox
        v-model="disease[DiseaseTypes.asthma].isSelected"
        label="Asthma"
      />

      <div
        v-if="disease[DiseaseTypes.asthma].isSelected"
        class="questions-inner"
      >
        <h4>Hospitalizations?</h4>

        <v-radio-group
          v-model="disease[DiseaseTypes.asthma].hospitalizations"
          row
        >
          <v-radio label="Yes" :value="true" />
          <v-radio label="No" :value="false" />
        </v-radio-group>
      </div>

      <v-checkbox
        v-model="disease[DiseaseTypes.sleepApnea].isSelected"
        label="Sleep Apnea"
      />

      <div
        v-if="disease[DiseaseTypes.sleepApnea].isSelected"
        class="questions-inner"
      >
        <h4>Hospitalizations?</h4>

        <v-radio-group
          v-model="disease[DiseaseTypes.sleepApnea].hospitalizations"
          row
        >
          <v-radio label="Yes" :value="true" />
          <v-radio label="No" :value="false" />
        </v-radio-group>
      </div>

      <v-checkbox
        v-model="disease[DiseaseTypes.copd].isSelected"
        label="COPD"
      />

      <div v-if="disease[DiseaseTypes.copd].isSelected" class="questions-inner">
        <h4>Have you ever been prescribed oxygen?</h4>

        <v-radio-group
          v-model="disease[DiseaseTypes.copd].oxygenPrescribed"
          row
        >
          <v-radio label="Yes" :value="true" />
          <v-radio label="No" :value="false" />
        </v-radio-group>
      </div>

      <v-checkbox
        v-model="disease[DiseaseTypes.emphysema].isSelected"
        label="Emphysema"
      />

      <div
        v-if="disease[DiseaseTypes.emphysema].isSelected"
        class="questions-inner"
      >
        <h4>Have you ever been prescribed oxygen?</h4>

        <v-radio-group
          v-model="disease[DiseaseTypes.emphysema].oxygenPrescribed"
          row
        >
          <v-radio label="Yes" :value="true" />
          <v-radio label="No" :value="false" />
        </v-radio-group>
      </div>

      <v-checkbox v-model="plate.isRespiratoryOperations" label="None" />
    </div>

    <h3>Any maintenance conditions:</h3>

    <div class="mb-6">
      <v-checkbox
        v-model="disease[DiseaseTypes.depression].isSelected"
        label="Anxiety/Depression"
      />

      <div
        v-if="disease[DiseaseTypes.depression].isSelected"
        class="questions-inner"
      >
        <h4>Hospitalizations</h4>

        <v-radio-group
          v-model="disease[DiseaseTypes.depression].hospitalizations"
          row
        >
          <v-radio label="Yes" :value="true" />
          <v-radio label="No" :value="false" />
        </v-radio-group>
      </div>

      <v-checkbox
        v-model="disease[DiseaseTypes.bloodPressure].isSelected"
        label="Blood pressure"
      />

      <div
        v-if="disease[DiseaseTypes.bloodPressure].isSelected"
        class="questions-inner"
      >
        <v-text-field
          v-model="disease[DiseaseTypes.bloodPressure].medsCount"
          label="How any different meds?"
          class="input-short"
        />
      </div>

      <v-checkbox
        v-model="disease[DiseaseTypes.cholesterol].isSelected"
        label="Cholesterol"
      />

      <div
        v-if="disease[DiseaseTypes.cholesterol].isSelected"
        class="questions-inner"
      >
        <v-text-field
          v-model="disease[DiseaseTypes.cholesterol].medsCount"
          label="How any different meds?"
          class="input-short"
        />
      </div>

      <v-checkbox
        v-model="disease[DiseaseTypes.chronicPain].isSelected"
        label="Chronic Pain"
      />

      <div
        v-if="disease[DiseaseTypes.chronicPain].isSelected"
        class="questions-inner"
      >
        <h4>Hospitalizations</h4>

        <v-radio-group
          v-model="disease[DiseaseTypes.chronicPain].hospitalizations"
          row
        >
          <v-radio label="Yes" :value="true" />
          <v-radio label="No" :value="false" />
        </v-radio-group>
      </div>

      <v-checkbox v-model="plate.isMaintenanceConditions" label="None" />
    </div>

    <h3>
      Have you been treated for anything we haven't talked about in the last
      10yrs?
    </h3>

    <PlateFooter :onBack="onBack" :onSubmit="onSubmit" :isLoading="isLoading" />
  </div>
</template>

<script>
import { format } from 'date-fns';
import { PlatesSteps } from '@/common/variables';
import PlateFooter from '@/components/lead/plates/PlateFooter';
import { mapGetters } from 'vuex';
import { DiseaseTypes } from '@/common/variables';

export default {
  name: 'GeneralHealthPlate',
  components: {
    PlateFooter,
  },
  props: {
    agent: {
      type: Object,
    },
    lead: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      disease: 'plates/disease',
      isDisabledBranch: 'plates/branch',
    }),
    backPlate() {
      return this.isDisabledBranch
        ? PlatesSteps.disabledHealthSecond
        : PlatesSteps.health;
    },
  },
  data: () => ({
    DiseaseTypes,
    plate: null,
    isLoading: false,
  }),
  mounted() {
    const { data } = this.$store.getters['plates/dataByStep'](
      PlatesSteps.generalHealth
    );
    this.plate = data;
  },
  methods: {
    format,
    onBack() {
      this.$store.commit('plates/setStep', this.backPlate);
    },
    onSubmit() {
      this.$store.commit('plates/setStep', PlatesSteps.company);
      this.$store.dispatch('plates/updatePlate', this.lead);
    },
  },
};
</script>

<style scoped lang="scss">
.questions-inner {
  margin-left: 60px;
}

.input-short {
  max-width: 300px;
}
</style>